import { ActionValue } from '@keepeek/commons';

function isActionVisible(_a) {
    var isSelection = _a.isSelection, _b = _a.isBasket, isBasket = _b === void 0 ? false : _b, _c = _a.isShare, isShare = _c === void 0 ? false : _c, action = _a.action, shareTokenDownloadAuthorized = _a.shareTokenDownloadAuthorized, _d = _a.isRichElement, isRichElement = _d === void 0 ? false : _d, enabledActions = _a.enabledActions;
    if (enabledActions && !enabledActions.includes(action.value)) {
        return false;
    }
    if (action.hidden) {
        return false;
    }
    if (isRichElement && action.value === ActionValue.DOWNLOAD) {
        return false;
    }
    if (isShare && (!action.showForShare || !shareTokenDownloadAuthorized)) {
        return false;
    }
    return ((!isBasket &&
        ((isSelection && action.showForManyElement) || (!isSelection && action.showForOneElement))) ||
        (isBasket && action.showForBasket));
}

export { isActionVisible };
//# sourceMappingURL=utils.js.map
